import { Calendar, Settings } from "lucide-react";

export const PERIODS = [
  { key: "daily", label: "Daily" },
  { key: "weekly", label: "Weekly" },
  { key: "monthly", label: "Monthly" },
  { key: "quarterly", label: "Quarterly" },
  { key: "annually", label: "Annually" },
];

export default function FilterBar({ period, onPeriodChange, from, to, onCustomRangeChange, onManageStages }) {
  return (
    <div className="flex items-center gap-2 flex-wrap bg-white border border-gray-100 rounded-xl shadow-sm px-3 py-2 mb-4">
      <span className="text-xs text-gray-500 mr-1">Period</span>

      {PERIODS.map((p) => (
        <button key={p.key} onClick={() => onPeriodChange(p.key)} className={`px-2.5 py-1 rounded-md text-xs border transition-colors ${period === p.key ? "border-sky-400 bg-sky-50 text-sky-700" : "border-gray-200 bg-white text-gray-500 hover:bg-gray-50"}`}>
          {p.label}
        </button>
      ))}

      <span className="w-px h-5 bg-gray-200 mx-1" />

      <div className="flex items-center gap-1 text-xs text-gray-500">
        <Calendar size={14} />
        <input type="date" value={from || ""} onChange={(e) => onCustomRangeChange({ from: e.target.value, to })} className="border border-gray-200 rounded-md px-1.5 py-1 text-xs" />
        <span>-</span>
        <input type="date" value={to || ""} onChange={(e) => onCustomRangeChange({ from, to: e.target.value })} className="border border-gray-200 rounded-md px-1.5 py-1 text-xs" />
      </div>

      <button onClick={onManageStages} className="ml-auto flex items-center gap-1 px-2.5 py-1 rounded-md text-xs border border-gray-200 text-gray-500 hover:bg-gray-50">
        <Settings size={13} />
        <span>Manage stages</span>
      </button>
    </div>
  );
}
